import React, { useState, useEffect } from "react";
import Layout from "../../components/UI/layout";
import Products from "../../components/Products/Products";
import { getProductsByCategory } from "../../services/Products/getProductsByCategory";
import Loader from "../../components/Loader/Loader";
import { getAllCategories } from "../../services/Categories/getAllCateogories";
import { SEO as Seo } from "../../components/UI/seo";
import { getCategoryMetadata } from "../../services/Categories/getCategoryMetadata";

export async function getServerData({ params }) {
  
  function replaceHyphensWithSpaces(string) {
    const stringWithSpaces = string.replace(/-/g, " ");
    return stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1);
  }

  const params_category = params.category;
  const canonicalUrl = `https://peabody.com.ar/productos/${params_category}/`;
  const category = await replaceHyphensWithSpaces(params_category);

  const categoryDetail = await getCategoryMetadata(category);
  const categoryMetadata = categoryDetail?.metadata || {};

  return {
    props: {
      category,
      canonicalUrl,
      metadata: categoryMetadata
    },
  };
}

const ProductosPage = ({ serverData }) => {
  const { category } = serverData;
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [color, setColor] = useState([]);
  const [parentCategory, setParentCategory] = useState(null);
  const [countryOn, setCountryOn] = useState("");
  const [error, setError] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [parentCategoryImage, setParentCategoryImage] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const countryFromLocalStorage = localStorage.getItem("country");
      setCountryOn(countryFromLocalStorage);

      // Detectar dispositivo móvil
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    if (countryOn) {
      getProductsByCategory(countryOn, category)
        .then((data) => {
          setError(false);
          setProducts(data);
        })
        .catch(() => setError(true));
    }
  }, [countryOn, category]);

  useEffect(() => {
    if (countryOn) {
      getAllCategories(countryOn)
        .then((categories) => {
          setCategories(categories);
        })
        .catch((error) => console.log(error));
    }
  }, [countryOn]);

  useEffect(() => {
    // Buscar categoría actual
    const currentCategory = categories.find(
      (cat) => cat.name.toLowerCase() === category.toLowerCase()
    );

    if (currentCategory) {
      setColor(currentCategory.color);

      // Buscar el padre de la categoría actual
      const parentId = currentCategory.patternCategory;
      if (parentId) {
        const parent = categories.find((cat) => cat.id === parentId);
        setParentCategory(parent);

        // Asignar imagen del padre según dispositivo
        const parentImage = isMobile
          ? parent?.mobileImage
          : parent?.desktopImage;
        setParentCategoryImage(parentImage);
      } else {
        setParentCategory(null);
        setParentCategoryImage(null);
      }
    }
  }, [categories, category, isMobile]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (products.length === 0) {
        setError(true);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [products]);

  return (
    <Layout>
      <>
        {error ? (
          <div className="center">
            <h3>No se encontró ningún producto en la categoría {category}. </h3>
          </div>
        ) : (
          <>
            {categories.length === 0 ? (
              <Loader />
            ) : (
              <>
                {/* Mostrar imagen del padre */}
                {parentCategoryImage && (
                  <div className="category-image">
                    <img
                      src={parentCategoryImage}
                      alt={`Imagen de categoría padre ${parentCategory?.name}`}
                      style={{ width: "100%" }}
                    />
                  </div>
                )}
                <Products
                  countryOn={countryOn}
                  setCountry={setCountryOn}
                  color={color}
                  products={products}
                  category={category}
                  allCategories={categories}
                  parentCategory={parentCategory ? parentCategory.name : ""}
                />
              </>
            )}
          </>
        )}
      </>
    </Layout>
  );
};

export default ProductosPage;

export const Head = ({ serverData }) => {

  if (!serverData?.metadata) {
    return null;  // Evitar renderizar Head si los datos no están listos
  }

  const { category, canonicalUrl, metadata } = serverData;

  return (
    <Seo title={metadata.title || `${category} | Peabody Argentina`} description={metadata.description}>
      <link rel="canonical" href={canonicalUrl}/>
    </Seo>
  )
}
